import type { ReactNode } from 'react';

export const symbol_yakitori: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M678-240 573-135q-17.38 17-42.69 17T488-135l-75-75q-17-17.38-17-42.69T413-295l17-17-75-75-17 17q-17.38 17-42.69 17T253-370l-75-75q-17-17.38-17-42.69T178-530l17-17-75-75q-17-17.38-17-42.69T120-707l46-46-85-84q-9-9-8.5-21t9.34-21q8.84-9 21-9t21.16 9l84 85 46-46q17.19-17 42.59-17Q322-857 339-840l75 75 17-16q17.12-17 42.06-17T515-781l76 75q17 17.19 17 42.59Q608-638 591-621l-17 16 75 75 17-16q17.38-17 42.69-17T751-546l75 75q17 17.19 17 42.59Q843-403 826-386L721-282l158 159q9 9 9 21t-9 21q-9 9-21 9t-21-9L678-240Zm-147 63 253-252-76-75-252 252 75 75Zm-58-177 134-134-76-75-134 134 76 75Zm-177-59 252-251-75-75-252 251 75 75Zm-59-176 135-134-76-75-134 134 75 75Zm383 248ZM502-459ZM385-576ZM267-694Z"
		/>
	</svg>
);
